import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { BRAND } from "@/lib/brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CheckoutReturn() {
  const { ident } = useParams();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current || !ident) return;
    ran.current = true;

    (async () => {
      try {
        const { data } = await axios.post(`${API}/checkout/${ident}/finalize`);
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
          return;
        }
        if (window.Tebex?.checkout && data.basket_ident) {
          window.Tebex.checkout.init({ ident: data.basket_ident, theme: "dark" });
          window.Tebex.checkout.launch();
          return;
        }
        setError(data.message || "We couldn't open the Tebex checkout.");
      } catch (e) {
        setError("We couldn't open the Tebex checkout.");
      }
    })();
  }, [ident]);

  return (
    <main className="grid min-h-screen place-items-center bg-[#08080a] px-6" data-testid="checkout-return">
      <div className="max-w-lg text-center">
        <img src={BRAND.lockup} alt="Orvyn FiveM Scripts" className="mx-auto h-12 w-auto" />
        {error ? (
          <>
            <h1 className="mt-10 font-display text-3xl font-extrabold uppercase tracking-tight text-white">
              Something went wrong
            </h1>
            <p className="mt-5 text-sm leading-relaxed text-white/45">{error}</p>
            <div className="mt-10 flex flex-wrap justify-center gap-3">
              <Link
                to="/"
                className="bg-white px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-black"
              >
                Start again
              </Link>
              <a
                href={BRAND.discord}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-white/18 px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-white/70 transition-colors hover:border-white/45 hover:text-white"
              >
                Get help
              </a>
            </div>
          </>
        ) : (
          <>
            <div className="mt-10 flex items-center justify-center gap-3">
              <Loader2 className="h-4 w-4 animate-spin text-[hsl(var(--orv-blue))]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/60">
                Preparing your checkout
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/40">
              Account linked. Taking you to secure Tebex checkout…
            </p>
          </>
        )}
      </div>
    </main>
  );
}
